module.exports = __webpack_public_path__ + "static/media/next.9e01c98d.svg";